<template>
  <div v-show="visible" class="ref-info-box">
    <div class="title">任务成果</div>
    <el-form ref="form" :model="form" label-position="left" label-width="127px" class="form-group">
      <el-form-item
        v-for="(control, index) in displayControls"
        :key="index"
        label="任务标题"
        prop="name"
      >
        <template slot="label">
          <span v-if="control.required" class="require-flag">*</span>
          {{ control.name }}
        </template>
        <el-input :value="''" disabled></el-input>
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
import { getSheetDefForEdit } from "@/api/sheet/sheet"
export default {
  name: "ref-info",
  props: {
    taskType: Object
  },
  data() {
    return {
      companySheets: {
        requested: false,
        data: []
      },
      sheetInfo: null,
      form: {}
    }
  },
  computed: {
    visible() {
      return Boolean(this.hasRefField() && this.displayControls?.length)
    },
    displayControls() {
      if (!this.sheetInfo?.sheetId || !this.hasRefField()) return []
      let cidMap = this._.keyBy(this.taskType.fillCids, "cid")
      let controlMap = this._.keyBy(this.sheetInfo.controls, "_cid")
      return Object.keys(cidMap).reduce((acc, cid) => {
        let control = controlMap[cid]
        if (!control) return acc
        control.required = cidMap[cid].type == "H"
        acc.push(control)
        return acc
      }, [])
    }
  },
  watch: {
    visible(val) {
      this.$emit("visible-change", val)
    }
  },
  methods: {
    init() {
      if (!this.hasRefField()) return
      let sheetId = this.taskType?.refSheetId
      getSheetDefForEdit(sheetId).then(sheetDef => {
        this.sheetInfo = sheetDef
      })
    },
    hasRefField() {
      return Boolean(this.taskType?.id && this.taskType?.fillCids?.length)
    }
  }
}
</script>

<style lang="scss" scoped>
.ref-info-box {
  .title {
    position: relative;
    margin-bottom: 20px;
    color: $color-font-first;
    font-size: $font-size-title-topic;
    line-height: 28px;
    &::before {
      content: "";
      position: absolute;
      left: -22px;
      width: 6px;
      height: 28px;
      border-radius: 4px;
      background-color: $color-main;
    }
  }
  .form-group {
    display: flex;
    flex-wrap: wrap;
    align-content: flex-start;
    .el-form-item {
      position: relative;
      margin-bottom: 8px;
      font-size: 14px;
      // height: 32px;
      // line-height: 30px;
      &:nth-child(odd) {
        width: 51%;
      }
      &:nth-child(even) {
        width: 49%;
        box-sizing: border-box;
      }
      .require-flag {
        color: red;
        font-size: 24px;
        padding-right: 4px;
        padding-top: 10px;
      }
      .icon-tip {
        margin-left: 4px;
        font-size: 16px;
        &:hover {
          color: #3aacf8;
        }
      }
      .parent-task {
        color: $color-main;
        cursor: pointer;
      }
      ::v-deep {
        .el-form-item__label {
          min-height: 40px;
          display: flex;
          align-items: center;
          line-height: 18px;
          padding: 0;
          padding-right: 12px;
        }
        .el-form-item__content {
          width: 320px;
          .el-date-editor,
          .el-select {
            width: 100%;
          }
        }
        .el-form-item__error {
          position: relative;
        }
        .color-main .el-input__inner {
          color: $color-font-first;
        }
      }
    }
  }
}
</style>
